<template>
  <svg width="63" height="63" viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="31.5" cy="31.5" r="28" stroke="black" stroke-width="2"/>
    <transition name="fade">
      <circle v-if="!active" cx="31.5" cy="31.5" r="23" stroke="red" fill="red"/>
    </transition>
    <transition name="fade">
      <rect v-if="active" x="18.4" y="18.4" width="26" height="26" rx="3" stroke="red" fill="red"></rect>
    </transition>
  </svg>
</template>

<script>
  export default {
    name: 'RecordIcon',
    props: {
      active: Boolean
    }
  }
</script>
